if (!customElements.get('upload-artwork-boxes')) {
  customElements.define(
    'upload-artwork-boxes',
    class UploadArtWorkBoxes extends HTMLElement {
      constructor() {
        super();

        this.maxFileSizeInMB = 100 * 1024 * 1024;
        this.acceptedFileTypes = [
          'image/jpeg',
          'image/png',
          'image/svg+xml',
          'application/pdf',
          'application/postscript',
        ];
        this.apiBaseUrl = 'https://api.cloudinary.com/v1_1/arka';
        this.allowedStatus = ['not-started', 'waiting', 'loaded', 'loading'];

        this.uploaded = [];
        this.instructions = [];
        this._status = 'not-started';

        this.contentButtons = this.querySelector('.content-buttons');
        this.containerItems = this.querySelector('.content-input-file');

        this.note = this.querySelector('textarea');
        if (this.note) {
          this.note.addEventListener('input', () => {
            this.instructions[0] = this.note.value;
          });
        }

        this.uploadInput = this.querySelector('.upload-artwork-btn');
        this.uploadLabel = this.querySelector(`label[for="${this.uploadInput.id}"]`);
        if (this.uploadInput) {
          this.uploadInput.addEventListener('change', () => this.handleUpload(this.uploadInput));
        }

        this.startBtn = this.querySelector('.start-upload');
        if (this.startBtn) {
          this.startBtn.addEventListener('click', () => {
            this.init();
          });
        }

        this.productForm = this.querySelector('product-form');
      }

      get files() {
        return this.containerItems.querySelectorAll('.item-file');
      }

      get status() {
        return this._status;
      }

      set status(status = 'waiting') {
        this._status = status;

        this.allowedStatus.forEach((s) => {
          this.classList.remove(s);
        });

        this.uploadLabel.textContent = 'Upload a File';
        if (status === 'loading') {
          this.uploadLabel.textContent = 'Uploading';
        }

        this.containerItems.classList.add('hidden');
        if (this.files.length > 0) {
          this.containerItems.classList.remove('hidden');
        }

        this.productForm.classList.add('hidden');
        this.productForm.submitting = true;
        if (this.uploaded.length > 0) {
          this.productForm.submitting = false;
          this.productForm.classList.remove('hidden');
        }

        this.classList.add(status);
      }

      init() {
        this.status = 'waiting';
        this.uploaded = [];
        this.note.value = '';
        this.uploadInput.value = '';
      }

      async handleUpload(input) {
        try {
          this.status = 'loading';

          for (let file of input.files) {
            const {data, error} = await this.uploadFile(file);

            if (!error) this.uploaded.push(data);

            let asset_id = new Date().getTime();
            if (data && data.asset_id) {
              asset_id = data.asset_id;
            }

            const itemFile = document.createElement('div');
            itemFile.classList.add('item-file');
            itemFile.setAttribute('data-asset_id', asset_id);
            if (error !== '') itemFile.classList.add('error');

            const fileName = document.createElement('span');
            fileName.classList.add('file-name');
            fileName.innerText = file.name;

            const fileError = document.createElement('span');
            fileError.classList.add('file-error');
            fileError.innerText = error;

            const input = document.createElement('input');
            input.classList.add('replace-btn');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', this.acceptedFileTypes.join(', '));
            input.setAttribute('id', `replace-upload-${asset_id}`);

            const buttonReplaceEdit = document.createElement('div');
            buttonReplaceEdit.classList.add('button-replace-edit');

            const replaceBtn = document.createElement('label');
            replaceBtn.setAttribute('for', `replace-upload-${asset_id}`);
            replaceBtn.innerText = 'replace';

            const em = document.createElement('em');
            em.innerText = '|';

            const removeBtn = document.createElement('button');
            removeBtn.classList.add('remove-btn');
            removeBtn.innerText = 'delete';

            buttonReplaceEdit.appendChild(input);
            buttonReplaceEdit.appendChild(replaceBtn);
            buttonReplaceEdit.appendChild(em);
            buttonReplaceEdit.appendChild(removeBtn);

            itemFile.appendChild(fileName);
            itemFile.appendChild(fileError);
            itemFile.appendChild(buttonReplaceEdit);

            this.containerItems.appendChild(itemFile);

            input.addEventListener('change', () => {
              this.replaceItem(itemFile, input);
            });

            removeBtn.addEventListener('click', () => {
              this.removeItem(itemFile);
            });
          }

          if (this.uploaded.length < 1) this.status = 'waiting';
          else this.status = 'loaded';
        } catch (error) {
          console.log(error);
        }
      }

      async replaceItem(item, input) {
        try {
          const file = input.files[0] || null;
          if (!file) return;

          this.status = 'loading';

          const asset_id = item.dataset.asset_id || '';
          const index = this.uploaded.findIndex((upload) => upload.asset_id === asset_id);

          const {data, error} = await this.uploadFile(file);

          if (index !== -1 && data) {
            this.uploaded[index] = data;
          } else if (index !== -1 && !data) {
            this.uploaded.splice(index, 1);
          } else if (index === -1 && data) {
            this.uploaded.push(data);
          }

          item.dataset.asset_id = new Date().getTime();
          if (data && data.asset_id) {
            item.dataset.asset_id = data.asset_id;
          }

          const fileName = item.querySelector('.file-name');
          fileName.innerText = file.name;

          const fileError = item.querySelector('.file-error');
          fileError.innerText = error;

          item.classList.toggle('error', error !== '');

          if (this.uploaded.length < 1) this.status = 'waiting';
          else this.status = 'loaded';
        } catch (error) {
          console.log(error);
        }
      }

      removeItem(item) {
        try {
          const asset_id = item.dataset.asset_id || '';

          const index = this.uploaded.findIndex((upload) => upload.asset_id === asset_id);

          let deleteToken = '';
          if (this.uploaded[index] && this.uploaded[index].delete_token) {
            deleteToken = this.uploaded[index].delete_token;
          }

          if (index !== -1 && deleteToken !== '') {
            fetch(`${this.apiBaseUrl}/delete_by_token`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                token: deleteToken,
              }),
            });

            this.uploaded.splice(index, 1);
          }

          item.remove();

          if (this.uploaded.length < 1) this.status = 'waiting';
          else this.status = 'loaded';
        } catch (error) {
          console.log(error);
        }
      }

      async uploadFile(file) {
        let data = null;

        try {
          if (!this.acceptedFileTypes.includes(file.type)) {
            throw new Error('Upload failed. File type is not accepted.');
          }

          if (file.size > this.maxFileSizeInMB) {
            throw new Error('Upload failed. File must be less than 100MB.');
          }

          data = await this._uploadFileToCloudinary(file);
          if (!data) {
            throw new Error('Upload failed. Try again.');
          }

          if (data.resource_type === 'image' && data.image_metadata.DPI < 300 && data.format != 'svg') {
            throw new Error('Upload failed. File must be at least 300 dpi.');
          }

          return {
            data,
            error: '',
          };
        } catch (error) {
          return {
            data,
            error: error.message,
          };
        }
      }

      async _uploadFileToCloudinary(file) {
        try {
          const formData = new FormData();

          formData.append('file', file);
          formData.append('upload_preset', 'rnxozoqn');

          return fetch(`${this.apiBaseUrl}/upload`, {
            method: 'POST',
            body: formData,
          }).then((res) => res.json());
        } catch (error) {
          console.log(error);

          return null;
        }
      }
    },
  );
}
